export default {
  short_description: 'Save time & earn rewards!',
  full_description:
    'The {{name}} App is here – for even easier ordering:\n\n• Super fast ordering via app\n\n• Immediate notifications about promotions and rewards\n\n• Collect and redeem your points easily\n\n• Track the status of your order in real time\n\nWe are happy to offer you our app – and hope you have as much fun with it as we do!`',
};
